<script setup>
import { onUnmounted, ref } from 'vue'
import { useDisplay } from 'vuetify'
import {howClassinoHelpsYouSlides} from '@/constants/howClassinoHelpsYouSlides'
const { mdAndDown } = useDisplay()
import { useRouter } from 'vue-router'
const router = useRouter()
const onboarding = ref(2)
const width = ref(200)
const slides = ref()
slides.value = howClassinoHelpsYouSlides
const slideGroup = ref(null)
const gotoFilteredCourses = (params) => {
  router.push(params)
}
setTimeout(() => {
  if (mdAndDown.value) {
    width.value = slideGroup.value.$el.clientWidth / 1.25
  } else {
    width.value = slideGroup.value.$el.clientWidth / 1.9
  }
}, 200)
const interval = setInterval(() => {
  onboarding.value < 3 ? onboarding.value++ : onboarding.value = 0
}, 7000)
const changeSlideHandler=(state)=>{
  state ==='prev'? onboarding.value-- : onboarding.value++
  onboarding.value > slides.value.length-1 ||  onboarding.value <= 0 ? onboarding.value= 0 : ''
}
onUnmounted(()=>{
  clearInterval(interval)
})
</script>

<template>
  <v-container tag="section" class="cl__section__margin__bottom">
    <v-row class="mb-16">
      <v-col cols="12" class="d-flex justify-center text-center">
        <h2 class="font-weight-bold cl-section__title"> کلاسینو چه کمکی بهت می‌کنه؟</h2>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="position-relative">
        <div v-if="!$vuetify.display.mobile" @click="changeSlideHandler('prev')" class="position-absolute" style="top: 50%; right: -15px; cursor: pointer">
          <i class="icon-angle-right slider-prev"></i>
        </div>
        <v-slide-group
          v-model="onboarding"
          center-active
          ref="slideGroup"
          mobile-breakpoint="xxl"
          :show-arrows="false"
          mobile
          breakpoint="xl"
        >
          <v-slide-group-item
            v-for="slide in slides"
            :key="slide"
            v-slot="{ select }"
          >
            <div class="subheader__card ma-4 rounded-xl">
              <h3 class="m-4">{{ slide.subheader }}</h3>
              <v-card
                :style="slide.bg_color"
                class="rounded-xl"
                height="400"
                :width="width"
                @click="gotoFilteredCourses(slide.cta.link)"
              >
                <div class="slide__overlay d-flex flex-column pt-8 p-5 ">
                  <h4 v-if="$vuetify.display.mdAndDown" class="mb-2 header">{{ slide.header }}</h4>
                  <h3 v-else class="mb-10 header">{{ slide.header }}</h3>
                  <v-list bg-color="transparent" role="article">
                    <v-list-item
                      role="doc-subtitle"
                      class="p-0"
                      v-for="(item,index) in slide.content"
                      :key="index"
                    >
                      <p class="why__slide__content">{{ item }}</p>
                    </v-list-item>
                  </v-list>
                  <div class="cta__box d-flex flex-column align-center">
                    <span class="text-white mb-2 ">{{ slide.cta.sub_text }}</span>
                    <v-btn style="letter-spacing: 0" class="cta__btn text-decoration-none rounded-lg elevation-0 mt-0"
                           @click="gotoFilteredCourses(slide.cta.link)" :to="slide.cta.link">
                      <span
                        :style="slide.bg_color+'background-clip: text; -webkit-background-clip: text;-webkit-text-fill-color: transparent;'">{{ slide.cta.text }}</span>
                    </v-btn>
                  </div>
                </div>
              </v-card>
            </div>
          </v-slide-group-item>
        </v-slide-group>
        <div @click="changeSlideHandler('next')"  class="position-absolute" style="top: 50%; left: -20px; cursor: pointer">
          <i class="icon-angle-left slider-next"></i>
        </div>
        <div class="dots-slider-container">
          <div
            v-for="(slide, index) in slides"
            :key="'dots-' + index"
            :class="['dots', { active: onboarding === index }]"
            @click="onboarding = index"
          ></div>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<style scoped lang="scss">
.not__selected {
  opacity: 0.3;
}
.dots-slider-container {
  display: flex;
  justify-content: center;
  margin-top: 16px;
}

.dots {
  width: 12px;
  height: 12px;
  cursor: pointer;
  margin: 0 5px;
  border-radius: 50%;
  background-color: grey;
  transition: width 0.3s, background-color 0.3s;
}

.dots.active {
  width: 55px;
  border-radius: 5px;
  background-color: gray;
}
.subheader__card {
  background: #F9FAFB;

  h3 {
    color: rgba(102, 112, 133, 1);
    font-weight: 700;
    &:nth-child(1){
      font-size: 20px;
    }
  }

  .slide__overlay {
    backdrop-filter: blur(64px);
    height: 100%;
    width: 100%;
    background: rgba(255, 255, 255, 0.3);
    color: #fff;
    position: relative;

    .header {
      color: #fff;
      font-weight: 900;
      text-shadow: 0px 3px 4px rgba(0, 0, 0, 0.09);
    }

    .why__slide__content {
      font-weight: 700;
      font-size: 1.3rem;
      @include media-breakpoint-down(md) {
        font-size: 1rem;
      }
    }

    .cta__box {
      position: absolute;
      left: 15px;
      bottom: 15px;

      span {
        font-weight: 600;
      }

      .cta__btn {
        background-color: rgba(255, 255, 255, 0.90);
        font-size: 19px;
      }
    }

  }
}

</style>
